import { Injectable } from "@angular/core";

@Injectable()
export class AuthenticationService {
    public campaignCreated = false;
}
